import * as CreDtos from "../CRE.dtos";

export type ForumAction = {
    type: string,

    //getForumListRequest getForumUpdateRequest
    email?: string,

    //getForumSuccess getForumUpdateSuccess loadPostSuccess
    forum?: CreDtos.Forum,

    //saveForumPostReactionRequest
    forumMemberId?: number,

    //loadPostRequest saveForumPostReactionRequest
    forumPostId?: number,

    //getForumListSuccess
    forums?: CreDtos.Forum[],

    //getForumDataRequest getForumRequest getForumUpdateRequest loadPostRequest saveForumPostReactionRequest saveTagRequest subscribeForumRequest
    id?: number,

    //subscribeForumSuccess
    isSubscribed?: boolean,

    //savePostReactionSuccess
    post?: CreDtos.ForumPost,

    //getForumFailure getForumListFailure getForumUpdateFailure savePostFailure saveTagFailure
    responseStatus?: CreDtos.ResponseStatus,

    //getForumDataRequest getForumRequest
    summary?: boolean,

    //changeActiveTab
    tab?: string,

    //saveTagRequest saveTagSuccess
    tag?: CreDtos.ForumTag
}

export const
    ACTIVE_TAB = "ACTIVE_TAB",
    ACTIVE_TAG = "ACTIVE_TAG",

    ADD_REMOVE_POST_TAG_FAILURE = "ADD_REMOVE_POST_TAG_FAILURE",
    ADD_REMOVE_POST_TAG_REQUEST = "ADD_REMOVE_POST_TAG_REQUEST",
    ADD_REMOVE_POST_TAG_SUCCESS = "ADD_REMOVE_POST_TAG_SUCCESS",

    CLEAR_FORUM = "CLEAR_FORUM",
    EDIT_FORUM = "EDIT_FORUM",

    FOLLOW_POST_FAILURE = "FOLLOW_POST_FAILURE",
    FOLLOW_POST_REQUEST = "FOLLOW_POST_REQUEST",
    FOLLOW_POST_SUCCESS = "FOLLOW_POST_SUCCESS",

    GET_FORUM_LIST_FAILURE = "GET_FORUM_LIST_FAILURE",
    GET_FORUM_LIST_REQUEST = "GET_FORUM_LIST_REQUEST",
    GET_FORUM_LIST_SUCCESS = "GET_FORUM_LIST_SUCCESS",

    GET_FORUM_DATA_REQUEST = "GET_FORUM_DATA_REQUEST",
    GET_FORUM_FAILURE = "GET_FORUM_FAILURE",
    GET_FORUM_REQUEST = "GET_FORUM_REQUEST",
    GET_FORUM_SUCCESS = "GET_FORUM_SUCCESS",

    GET_FORUM_UPDATE_FAILURE = "GET_FORUM_UPDATE_FAILURE",
    GET_FORUM_UPDATE_REQUEST = "GET_FORUM_UPDATE_REQUEST",
    GET_FORUM_UPDATE_SUCCESS = "GET_FORUM_UPDATE_SUCCESS",

    LOAD_FORUM_REQUEST = "LOAD_FORUM_REQUEST",

    LOAD_POST_FAILURE = "LOAD_POST_FAILURE",
    LOAD_POST_REQUEST = "LOAD_POST_REQUEST",
    LOAD_POST_SUCCESS = "LOAD_POST_SUCCESS",

    SAVE_FORUM_FAILURE = "SAVE_FORUM_FAILURE",
    SAVE_FORUM_REQUEST = "SAVE_FORUM_REQUEST",
    SAVE_FORUM_SUCCESS = "SAVE_FORUM_SUCCESS",

    SAVE_POST_FAILURE = "SAVE_POST_FAILURE",
    SAVE_POST_REQUEST = "SAVE_POST_REQUEST",
    SAVE_POST_SUCCESS = "SAVE_POST_SUCCESS",

    SAVE_POST_REACTION_REQUEST = "SAVE_POST_REACTION_REQUEST",

    SAVE_TAG_FAILURE = "SAVE_TAG_FAILURE",
    SAVE_TAG_REQUEST = "SAVE_TAG_REQUEST",
    SAVE_TAG_SUCCESS = "SAVE_TAG_SUCCESS",

    SUBSCRIBE_REQUEST = "SUBSCRIBE_REQUEST",
    SUBSCRIBE_SUCCESS = "SUBSCRIBE_SUCCESS",

    SEARCH_FAILURE = "SEARCH_FAILURE",
    SEARCH_REQUEST = "SEARCH_REQUEST",
    SEARCH_SUCCESS = "SEARCH_SUCCESS",

    SEARCH_POST_FAILURE = "SEARCH_POST_FAILURE",
    SEARCH_POST_REQUEST = "SEARCH_POST_REQUEST",
    SEARCH_POST_SUCCESS = "SEARCH_POST_SUCCESS",

    SWITCH_FORUM = "SWITCH_FORUM";

export function changeActiveTab(tab: string): ForumAction {
    return {
        type: ACTIVE_TAB,
        tab
    };
}

export function getForumListRequest(email: string): ForumAction {
    return {
        type: GET_FORUM_LIST_REQUEST,
        email
    };
}

export function getForumListSuccess(forums: CreDtos.Forum[]): ForumAction {
    return {
        type: GET_FORUM_LIST_SUCCESS,
        forums
    };
}

export function getForumListFailure(responseStatus: CreDtos.ResponseStatus): ForumAction {
    return {
        type: GET_FORUM_LIST_FAILURE,
        responseStatus
    };
}

export function getForumUpdateRequest(id: number, email: string): ForumAction {
    return {
        type: GET_FORUM_UPDATE_REQUEST,
        id,
        email
    };
}

export function getForumUpdateSuccess(forum: CreDtos.Forum): ForumAction {
    return {
        type: GET_FORUM_UPDATE_SUCCESS,
        forum
    };
}

export function getForumUpdateFailure(responseStatus: CreDtos.ResponseStatus): ForumAction {
    return {
        type: GET_FORUM_UPDATE_FAILURE,
        responseStatus
    };
}

export function getForumDataRequest(id: number, summary: boolean): ForumAction {
    return {
        type: GET_FORUM_DATA_REQUEST,
        id,
        summary
    };
}

export function getForumRequest(id: number, summary: boolean): ForumAction {
    return {
        type: GET_FORUM_REQUEST,
        id,
        summary
    };
}

export function getForumSuccess(forum: CreDtos.Forum): ForumAction {
    return {
        type: GET_FORUM_SUCCESS,
        forum
    };
}

export function getForumFailure(responseStatus: CreDtos.ResponseStatus): ForumAction {
    return {
        type: GET_FORUM_FAILURE,
        responseStatus
    };
}

export function saveForumRequest(forum) {
    return {
        type: SAVE_FORUM_REQUEST,
        forum
    };
}
export function saveForumSuccess(response) {
    return {
        type: SAVE_FORUM_SUCCESS,
        forum: response.forum
    };
}
export function saveForumFailure(responseStatus) {
    return {
        type: SAVE_FORUM_FAILURE,
        responseStatus
    };
}

export function saveForumPostReactionRequest(id: number, forumMemberId: number, forumPostId: number): ForumAction {
    return {
        type: SAVE_POST_REACTION_REQUEST,
        id,
        forumMemberId,
        forumPostId
    };
}

export function subscribeForumRequest(id: number, tag: any): ForumAction {
    return {
        type: SUBSCRIBE_REQUEST,
        id
    };
}
export function subscribeForumSuccess(response: CreDtos.SubscribeResponse): ForumAction {
    return {
        type: SUBSCRIBE_SUCCESS,
        isSubscribed: response.isSubscribed
    };
}

export function saveTagRequest(id: number, tag: CreDtos.ForumTag): ForumAction {
    return {
        type: SAVE_TAG_REQUEST,
        tag,
        id
    };
}

export function saveTagSuccess(response: CreDtos.ForumTagResponse): ForumAction {
    return {
        type: SAVE_TAG_SUCCESS,
        tag: response.tag
    };
}

export function saveTagFailure(responseStatus: CreDtos.ResponseStatus): ForumAction {
    return {
        type: SAVE_TAG_FAILURE,
        responseStatus
    };
}


/*Posts*/
export function savePostReactionSuccess(response: CreDtos.ForumPostResponse): ForumAction {
    var post = response.post;
    return {
        type: SAVE_POST_SUCCESS,
        post: post
    };
}

export function loadPostRequest(id: number, forumPostId: number): ForumAction {
    return {
        type: LOAD_POST_REQUEST,
        id,
        forumPostId
    };
}

export function loadPostSuccess(response: CreDtos.ForumResponse): ForumAction {
    return {
        type: LOAD_POST_SUCCESS,
        forum: response.forum
    };
}

export function savePostRequest(id, post, tags) {
    return {
        type: SAVE_POST_REQUEST,
        id,
        post,
        tags
    };
}
export function savePostSuccess(response) {
    var post = response.post;
    post.active = true;
    return {
        type: SAVE_POST_SUCCESS,
        post: post
    };
}

export function savePostFailure(responseStatus: CreDtos.ResponseStatus): ForumAction {
    return {
        type: SAVE_POST_FAILURE,
        responseStatus
    };
}

export function searchPostRequest(id, term) {
    return {
        type: SEARCH_POST_REQUEST,
        id,
        term
    };
}
export function searchPostSuccess(response) {
    return {
        type: SEARCH_POST_SUCCESS,
        posts: response.posts
    };
}

export function searchPostFailure(responseStatus) {
    return {
        type: SEARCH_POST_FAILURE,
        responseStatus
    };
}

export function searchRequest(email, term) {
    return {
        type: SEARCH_REQUEST,
        email,
        term
    };
}
export function searchSuccess(response) {
    return {
        type: SEARCH_SUCCESS,
        forums: response.forums
    };
}

export function searchFailure(responseStatus) {
    return {
        type: SEARCH_FAILURE,
        responseStatus
    };
}

/* Attach Member Tags */
export function followPostRequest(postId, subscribed) {
    return {
        type: FOLLOW_POST_REQUEST,
        postId,
        subscribed
    };
}

export function followPostSuccess(response) {
    return {
        type: FOLLOW_POST_SUCCESS,
        postId: response.postId,
        subscribed: response.subscribed
    };
}

export function followPostFailure(responseStatus) {
    return {
        type: FOLLOW_POST_FAILURE,
        responseStatus
    };
}

/* Attach Tags */
export function savePostTagRequest(postId, tagId) {
    return {
        type: ADD_REMOVE_POST_TAG_REQUEST,
        postId,
        tagId
    };
}

export function savePostTagSuccess(response) {
    return {
        type: ADD_REMOVE_POST_TAG_SUCCESS,
        tag: response.tag,
        postId: response.postId
    };
}

export function savePostTagFailure(responseStatus) {
    return {
        type: ADD_REMOVE_POST_TAG_FAILURE,
        responseStatus
    };
}


export function editForum(id) {
    return {
        type: EDIT_FORUM,
        id
    };
}
export function clearForum() {
    return {
        type: CLEAR_FORUM,
    };
}

export function activeTag(tag) {
    return {
        type: ACTIVE_TAG,
        tag
    };
}

export function switchForum() {
    return {
        type: SWITCH_FORUM
    };
}



// WEBPACK FOOTER //
// ./src/actions/forum.actions.ts